export function toJump(param) {
  return
  let is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
  if (is_mobi) {
    let host = location.host;
    let protocol = location.protocol;
    let pathname = location.pathname;
    let a = pathname.indexOf('/a');
    let p = pathname.indexOf('/p');
    let s = pathname.indexOf('/s');
    let u = pathname.indexOf('/u');
    let d = pathname.indexOf('/diypage');
    let c = pathname.indexOf('/course');
    let url = `${protocol}//${host}/m/#/`;
    if (a != -1 || p != -1 || s != -1 || u != -1 || c != -1 || d != -1) {
      let url = `${protocol}//${host}/m/#/${param}`;
      if (param) {
        location.href = url;
      }
    } else {
      location.href = url;
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/jump.js